import { render } from "./CollegeCounselingView.vue?vue&type=template&id=e02d7a3c"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__